import React from "react";
import {
  Flex,
  Table,
  ConfigProvider,
} from "antd";
import PrimaryButton from "../button/primarybutton";
const columns = [
  {
    title: "Order ID",
    width: 40,
    dataIndex: "orderID",
    key: "1",
    fixed: "left",
  },
  {
    title: "Plan Name",
    width: 50,
    dataIndex: "planName",
    sorter: true,
    key: "2",
  },
  {
    title: "Payment Type",
    dataIndex: "paymentType",
    key: "3",
    sorter: true,
    width: 50,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "4",
    width: 40,
  },
  {
    title: "Order Date",
    dataIndex: "orderDate",
    sorter: true,
    // render: (name) => `${name.first} ${name.last}`,
    key: "5",
    width: 40,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "6",
    width: 40,
    sorter: true,
  },
  {
    title: "Action",
    key: "17",
    fixed: "right",
    width: 40,
    render: () => (
      <PrimaryButton
            style={{
              width: "100px",
              height: "25px",
              fontSize: "12px",
              background: "#f5a524",
              borderRadius: "4px",
            }}
            text={"Payment Log"}
          />
    ),
  },
  {
    title: "Receipt",
    dataIndex: "accountStatus",
    key: "16",
    width: 40,
    render: () => (
      <PrimaryButton
            style={{
              width: "100px",
              height: "25px",
              fontSize: "12px",
              background: "#F8E6EF",
              borderRadius: "4px",
              color: "#BA0060"
            }}
            text={"Download"}
          />
    ),
  },
];
const data = [];
for (let i = 1; i < 50; i++) {
  data.push({
    key: i,
    orderID: `13000${i}`,
    planName: `Platinum`,
    paymentType: `Stripe`,
    amount: `107.99`,
    orderDate: `01 July 2024`,
    status: `On Payment`,
  });
}
export default function TransactionLogsComp() {

  return (
    <>
      <div className="w-full flex flex-col justify-between pt-8">
        <div className="w-full">
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#310048",
                  headerColor: "#ffffff",
                  cellFontSize: "14px",
                  headerSortHoverBg: "#310048",
                  headerSortActiveBg: "",
                },
              },
            }}
          >
            <Flex gap="middle" vertical>
              <Table
                className="user-list"
                bordered
                columns={columns}
                dataSource={data}
                pagination={{
                  pageSize: 10,
                }}
                scroll={{
                  x: 1000,
                  y: 600,
                }}
              />
            </Flex>
          </ConfigProvider>
        </div>
      </div>
    </>
  );
}
